export const iconsMargin = 8;
export const iconSize = 18;

export interface RightIcons {
    toolTipText?: string;
    additionalIcon?: { tooltipText: string; icon: JSX.Element };
    warningText?: string | JSX.Element;
}

export function getRightIconsStyle(props: RightIcons) {
    return {
        position: "absolute",
        right: getIconsContainerRight(props),
        top: 10,
        display: "flex",
        "& > *": {
            marginRight: iconsMargin + "px",
        },
    };
}

function getIconsContainerRight(props: RightIcons) {
    let numberOfIcons = 0;
    if (props.toolTipText) numberOfIcons++;
    if (props.additionalIcon) numberOfIcons++;
    if (props.warningText) numberOfIcons++;

    const iconWidth = iconSize * numberOfIcons;
    const marginWidth = iconsMargin * numberOfIcons;
    return `-${iconWidth + marginWidth + 13}px`;
}
